import Decimal from 'decimal.js';
// 加法
export const add = (a, b) => {
	return new Decimal(a).add(new Decimal(b)).toNumber();
};
// 减法
export const reduce = (a, b) => {
	return new Decimal(a).sub(new Decimal(b)).toNumber();
};
// 乘法
export const multiply = (a, b) => {
	return new Decimal(a).mul(new Decimal(b)).toNumber();
};
// 除法
export const division = (a, b) => {
	return new Decimal(a).div(new Decimal(b)).toNumber();
};
// 向上取整
export const ceil = (num) => {
	return new Decimal(num).ceil().toNumber();
};
// 有效数字(四舍五入)
export const effective = (num) => {
	return new Decimal(num).round().toNumber();
};
